// ─── Route Paths ────────────────────────────────────────────────────────────
export const ROUTE_PATHS = {
  HOME: "/",
  BREW: "/360brew",
  GIOVANNI: "/giovanni-burdi",
  ROI: "/the-roi-architect",
  VIEWPOINT: "/viewpoint-newsletter",
  RIDMIX: "/ridmix-music",
  STUDIO: "/creative-studio",
} as const;

// ─── Types ────────────────────────────────────────────────────────────────────
export interface ExperienceEntry {
  id: string;
  title: string;
  type: string;
  company: string;
  description: string;
  skills: string;
}

export interface ProfileInput {
  fullName: string;
  profileUrl: string;
  headline: string;
  about: string;
  skills: string;
  position: string;
  industry: string;
  experiences: ExperienceEntry[];
  servicesBio: string;
  servicesList: string;
}

export interface SectionAnalysis {
  score: number;
  analysis: string;
  suggestions: string[];
  optimizedText: string;
}

export interface ProfileAnalysis {
  headline: SectionAnalysis;
  about: SectionAnalysis;
  skills: SectionAnalysis;
  experience: SectionAnalysis;
  services: SectionAnalysis;
  coherence: SectionAnalysis;
  engagement: SectionAnalysis;
  pillars: SectionAnalysis;
  overallScore: number;
}

export type AnalysisSection = keyof Omit<ProfileAnalysis, "overallScore">;

// ─── Language Config ──────────────────────────────────────────────────────────
export type Language = "en" | "de" | "it";

export const LANGUAGES: { code: Language; label: string; flag: string }[] = [
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
];

// ─── Nav Links ────────────────────────────────────────────────────────────────
export const EXTERNAL_LINKS = {
  GIOVANNI_LINKEDIN: "https://www.linkedin.com/in/giovanni-burdi",
  ROI_ARCHITECT: "https://www.linkedin.com/company/111456048",
  VIEWPOINT: "https://www.linkedin.com/newsletters/the-viewpoint-6966512201872347136",
  RIDMIX: "https://linktr.ee/ridmix",
  CREATIVE_STUDIO: "https://9vepujdpw6.skywork.website/",
} as const;
